import { InvestigationView } from "@/shared/modules/typescript-trust-ti-api-client/models/investigation-view";
import { Module } from "vuex";


const investigationStoreModule: Module<any, any> = {
  state: {
    selectedInvestigation: {},
  },
  mutations: {
    setSelectedInvestigation(state, i: InvestigationView) {
      state.selectedInvestigation = i;
    }

  },
  actions: {
    setSelectedInvestigation({ commit }, i: InvestigationView) {
      commit('setSelectedInvestigation', i);
    }
  },
  getters: {
    getSelectedInvestigation: (state) => state.selectedInvestigation,
  }
}
export default investigationStoreModule;